import { render } from "./IYa.vue?vue&type=template&id=1dddd56e"
import script from "./IYa.vue?vue&type=script&lang=js"
export * from "./IYa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__